<script lang="ts">
  import CalendarMultiple from '~icons/mdi/calendar-multiple';
  import Shimmer from '~icons/mdi/shimmer';
  import Poll from '~icons/mdi/poll';
  import Sync from '~icons/mdi/sync';
  import CloudSync from '~icons/mdi/cloud-sync';
  import Search from '~icons/mdi/magnify';
  import SortAscending from '~icons/mdi/sort-ascending';
  import Coffee from '~icons/mdi/coffee';
  import { theme } from '~/theme/darkMode.svelte';
  import type { ModalSection } from '~/types';
  import Directory from '~/components/Directory.svelte';

  type Props = {
    hideSupport?: boolean;
  };
  const props: Props = $props();
  const publicAssets =
    'https://dohysbywpvqieovitawt.supabase.co/storage/v1/object/public/public-assets';

  const sections: ModalSection[] = [
    //{
      //id: 'beta',
      //icon: Shimmer,
      //desc: 'access beta game modes',
    //},
    {
      id: 'stats',
      icon: Poll,
      desc: 'more detailed stats',
    },
    {
      id: 'archive',
      icon: CalendarMultiple,
      desc: 'browse the puzzle archive',
    },
    {
      id: 'cloud-sync',
      icon: CloudSync,
      desc: 'cloud save across devices',
    },
    {
      id: 'search',
      icon: Search,
      desc: 'advanced word lookup',
    },
    {
      id: 'sort',
      icon: SortAscending,
      desc: 'sort your word history',
    },
  ];
</script>

<div class="premium">
  {#if !props.hideSupport}
    <div id="support" class="premium-header">
      <Coffee />
      <h2>Support development</h2>
    </div>
    <p>Say thanks by helping out with server and caffiene costs!</p>
    <p>
      Becoming a premium member is the best way to show your ❤️ for Gram Jam,
      plus it gives you exclusive access to premium features!
    </p>
  {/if}
  <h1 id="directory" class="premium-header">Premium Features</h1>
  <Directory {sections} />
  <!--<div id="beta" class="premium-header">
    <span class="beta-icon">Beta</span>
    <h2>Early beta access</h2>
  </div>
  <p>
    Test out new puzzle modes and provide feedback before they're publicly
    available.
  </p>
  <img
    alt="mini mode"
    width="80%"
    src="{publicAssets}/mini-{theme.current}.png"
  />-->
  <div id="stats" class="premium-header">
    <Poll />
    <h2>Daily stats</h2>
  </div>
  <p>
    Get more detailed stats on your games, and compare yourself to other
    players!
  </p>
  <img
    alt="daily stats"
    width="80%"
    src="{publicAssets}/star-stats-{theme.current}.gif"
  />
  <div id="archive" class="premium-header">
    <CalendarMultiple />
    <h2>Puzzle archive</h2>
  </div>
  <p>
    Gain access to the archive to replay daily puzzles and backup and sync your
    daily stats across devices.
  </p>
  <img
    alt="puzzle archive"
    width="80%"
    src="{publicAssets}/archive-{theme.current}.gif"
  />
  <div id="cloud-sync" class="premium-header">
    <CloudSync />
    <h2>Cloud save</h2>
  </div>
  <p>
    Daily streaks are synced across devices so you never have to lose your streak!
  </p>
  <p>
    Classic game progress is saved to the cloud so you can pick up where
    you left off on any device.
  </p>
    <p>No more losing your game when you switch
    browsers or clear your cache.
  </p>
  <img
    alt="cloud sync"
    width="80%"
    src="{publicAssets}/cloud-sync-{theme.current}.png"
  />
  <div id="search" class="premium-header">
    <Search />
    <h2>Advanced word lookup</h2>
  </div>
  <ul class="list">
    <li>insert <b>*</b> to match any character</li>
    <li>begin with <b>(</b> to match the middle of a word</li>
    <li>end with <b>]</b> to match the end of a word</li>
  </ul>
  <img
    alt="advanced search"
    width="80%"
    src="{publicAssets}/search-{theme.current}.gif"
  />
  <div id="sort" class="premium-header">
    <SortAscending />
    <h2>Word history sorting</h2>
  </div>
  <p>
    Sort your word history by the order words were found, by length, or by score
    to quickly find your best plays.
  </p>
  <img
    alt="word sort"
    width="80%"
    src="{publicAssets}/word-sort-{theme.current}.jpg"
  />
</div>

<style lang="scss">
  @use '~/theme/include-media' as *;

  .beta-icon {
    width: 100%;
    color: white;
    font-weight: bold;
    font-size: 12px;
    text-transform: uppercase;
    background: #eb5353;
    padding: 0.25em 0.5em;
    border-radius: 0.25em;
  }
  .premium {
    text-align: center;
    scroll-behavior: smooth;
  }
  .premium-header {
    display: grid;
    grid-auto-flow: column;
    align-items: center;
    justify-content: center;
    gap: 1em;
    h2 {
      width: 100%;
    }
    :global(svg) {
      font-size: 1.5rem;
    }
  }
  img {
    border: 2px solid black;
    border-radius: 1em;
    margin-left: auto;
    margin-right: auto;
    :global(html.dark-mode) & {
      border-color: white;
    }
  }
  .list {
    text-align: left;
    li {
      margin-left: 1rem;
    }
  }
</style>
